
/* injects from baggage-loader */

'use strict';

export default class AccountLogoutController {

	constructor($log, User) {
		'ngInject';

		this.$log = $log;
		this.UserService = User;

	}

	$onInit() {

		// Logout the current user and return to the home page
		this.UserService.logout('home');

	}

}



// WEBPACK FOOTER //
// ./src/app/pages/account-logout/account-logout.controller.js